<template>
  <div v-if="hasItems" class="v-navbar-menu-item">
    <div class="v-navbar-menu-item__link" @click="toggle()">
      <img v-if="icon === 'user'" src="./user-icon.svg" />
      <img v-if="icon === 'search'" src="./search-icon.svg" />
      <span>
        <slot name="default"></slot>
        <svg class="v-navbar-menu-item__arrow" width="8" height="5" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l2.667 2.63h0a.261.261 0 0 0 .366 0L6.7 1" stroke="#282828" stroke-width="1.75" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </span>
    </div>
    <div v-if="isOpen" class="v-navbar-menu-item__items">
      <div class="v-navbar-menu-item__items__wrapper">
        <slot name="items"></slot>
      </div>
    </div>
  </div>
  <div v-else :class="[
    'v-navbar-menu-item',
    {
      'v-navbar-menu-item__locked': requireAuth
    }
  ]">
    <a v-bind="{ href, target, title }" class="v-navbar-menu-item__link">
      <img v-if="icon === 'user'" src="./user-icon.svg" />
      <img v-if="icon === 'search'" src="./search-icon.svg" />
      <span>
        <svg v-if="requireAuth" class="v-navbar-menu-item__lock" width="15" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M12.75 7.125h-.562V5.062a5.063 5.063 0 0 0-10.125 0v2.063H1.5a1.5 1.5 0 0 0-1.5 1.5V16.5A1.5 1.5 0 0 0 1.5 18h11.25a1.5 1.5 0 0 0 1.5-1.5V8.625a1.5 1.5 0 0 0-1.5-1.5zm-5.625 6.75a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm3.188-7.125a.375.375 0 0 1-.375.375H4.313a.375.375 0 0 1-.375-.375V5.062a3.188 3.188 0 0 1 6.374 0V6.75z" fill="#CFCFD0" fill-rule="nonzero"/></svg>
        <slot name="default"></slot>
      </span>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false
    };
  },
  props: {
    icon: {
      type: String,
      default: null
    },
    href: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    }
  },
  computed: {
    hasItems() {
      return !!this.$slots.items || !!this.$scopedSlots.items;
    },
    requireAuth() {
      return !!this.$props.href && /SC_LOCKED/.test(this.$props.href);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-navbar-menu-item {
  position: relative;
  user-select: none;

  &__items {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
    z-index: 1000;

    &__wrapper {
      background: #fff;
      border-radius: $border-radius;
    }
  }

  & + & {
    margin-left: $spacer;

    @include media-breakpoint-up(lg) {
      margin-left: $spacer * 2;
    }

    .v-navbar-menu-item & {
      margin-left: 0;
    }
  }

  &__link {
    cursor: pointer;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: theme-color("dark");
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    font-size: 0.875rem;

    .v-navbar-menu-item__locked & {
      color: theme-color("gray-dark");
    }

    img {
      margin-bottom: $spacer * 0.25;
      width: 25px;
      height: 25px;

      @include media-breakpoint-up(lg) {
        width: 30px;
        height: 30px;
      }
    }

    span {
      display: block;
      white-space: nowrap;
    }

    svg.v-navbar-menu-item__arrow {
      position: relative;
      top: -1px;
      margin-left: 2px;
    }

    svg.v-navbar-menu-item__arrow {
      position: relative;
      top: -1px;
      margin-left: 2px;
    }

    svg.v-navbar-menu-item__lock {
      position: relative;
      top: 2px;
      margin-right: 5px;
    }
  }

  &__items {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);

    &__wrapper {
      margin-top: $spacer;
      min-width: 220px;
      background: #fff;
      border-radius: $border-radius;
      padding: $spacer;
      box-shadow: 0 18px 40px 0 rgba(0, 0, 0, 0.3);
      position: relative;
      animation-name: reveal;
      animation-duration: 200ms;
      animation-timing-function: ease-out;

      &::before {
        content: "";
        width: 20px;
        height: 20px;
        background: #ffff;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -40%) rotate(45deg);
      }
    }
  }

  &__items &__link {
    display: block;
    font-size: 1rem;
    text-align: left;
    transition: transform 200ms ease-out;
    padding: $spacer * 0.5 0;

    &:hover {
      color: theme-color("primary");
    }
  }
}
</style>
